import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';

import toast from 'react-hot-toast';
import FileDownload from 'js-file-download';
import planningService from '@services/planning.service';
import strftime from 'strftime';
import jwt_decode from 'jwt-decode';

const EP_Report = () => {
  // eslint-disable-next-line
  const token = jwt_decode(localStorage.getItem('plano-jwt'));
  const userName =
    token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

  const [epStatus, setEpStatus] = useState({});

  async function fethStatus() {
    const { data } = await planningService.Get('/irancell/ep_report/getFileStatus');
    setEpStatus(data);
  }
  const getSeverity = (docs) => {
    let hasCount = docs.docCount > 10 ? true : false;
    switch (hasCount) {
      case true:
        return 'success';
      case false:
        return 'danger';
      default:
        return null;
    }
  };
  const publicBodyTemplate = (docs) => {
    return <Tag value={docs.docCount} severity={getSeverity(docs)}></Tag>;
  };
  useEffect(() => {
    fethStatus();
    // eslint-disable-next-line
  }, [userName]);

  const onFinish = async () => {
    try {
      const res = await planningService.PostBlob(
        '/irancell/ep_report',
      );
      let nameOfFile = `EP-Report_${strftime('%Y-%m-%d-%H-%M-%S')}.zip`;
      FileDownload(res.data, nameOfFile);
    } catch (err) {
      console.log("err", err);
      toast.error(err);
    }
  };

  return (
    <div className="p-5 h-full img-bg img-bg-google-earth">
      <div className="bg-white border border-gray-200 rounded-md p-5 grid grid-cols-12 gap-2">
        <div className='col-span-11'>
          <p className='text-lg'>
            This report is generated using the files in the below table.
          </p>
          </div>
          <div className='col-span-11'>
          <p className='text-lg'>
            Please review this table before exporting to check if all files were <strong>
              imported on the same date
            </strong> and <strong>
            no files should have 0 in their docCount column.
            </strong>
          </p>
        </div>
        <Button
          className="mt-6 col-end-13"
          label="Download"
          raised
          onClick={onFinish}
        />
      </div>
      <div className='bg-white border border-gray-200 rounded-md p-5 grid'>
        <DataTable value={epStatus} tableStyle={{ minWidth: '50rem' }}>
          <Column field="Name" header="File Name"></Column>
          <Column body={publicBodyTemplate} header="Doc Count"></Column>
          <Column field="lastUpdate" header="Last Update"></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default EP_Report;
